import styled from '@emotion/styled'
import { colors, typography, Button } from '@resiliatech/birdsong'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'

export const UpdatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
`

export const UpdateItem = styled.div`
  margin-top: 16px;
  padding-bottom: 16px;
  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0; /* Adjust color as needed */
  }
`

export const UpdateAuthor = styled.div`
  ${typography.down2.regularSans};
  color: ${colors.common.black};
  margin-bottom: 12px;
`

export const UpdateDescription = styled.div`
  margin-bottom: 10px;
  ${typography.baseline.regularSans}
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ViewGoalButton = styled(Button)`
  display: flex;
  align-items: center;
  ${typography.down1.semiBoldSans};
  gap: 8px;
`

export const ArrowForward = styled(ArrowForwardIcon)`
  width: 18px;
  height: 18px;
`
